// eslint-disable-next-line import/order
import type { Command } from '@atlaskit/editor-common/types';
import type { EditorAgent } from '@atlassian/generative-ai-modal/utils/agents';

import type { RovoPublish } from '../../types/types';
import type { DecorationPositions } from '../decoration/actions';
import { createCommand } from './plugin-factory';
// eslint-disable-next-line import/order
import { ACTIONS } from './states';

export const updateAgents = ({
	agents,
	defaultAgent,
}: {
	agents: EditorAgent[];
	defaultAgent?: EditorAgent;
}): Command =>
	createCommand(() => {
		return {
			type: ACTIONS.UPDATE_PLUGIN_STATE,
			data: {
				// Exclude the default agent from the list of agents
				// See https://product-fabric.atlassian.net/browse/EDF-881
				agents: agents.filter((agent) => agent.namedId !== 'ai_mate_agent'),
				defaultAgent,
				initialised: true,
			},
		};
	});

export const openBrowseAgentsModal = (open: boolean, rawPositions?: number[]): Command => {
	// Convert rawPositions into a structured format if provided.
	// This ensures that when the browse agents modal is closed,
	// the selection is restored correctly.
	const positions: DecorationPositions | undefined = rawPositions && {
		startPos: rawPositions[0],
		endPos: rawPositions[1],
	};

	return createCommand(() => {
		return {
			type: ACTIONS.UPDATE_PLUGIN_STATE,
			data: {
				isBrowseModalOpen: open,
				positions,
			},
		};
	});
};

export const updatePublish = (publish: RovoPublish): Command => {
	return createCommand(() => {
		return {
			type: ACTIONS.UPDATE_PLUGIN_STATE,
			data: {
				publish,
			},
		};
	});
};

export const updateEnabled = (enabled: boolean): Command => {
	return createCommand(() => {
		return {
			type: ACTIONS.UPDATE_PLUGIN_STATE,
			data: {
				enabled,
			},
		};
	});
};
